import { render, staticRenderFns } from "./account-drawer.vue?vue&type=template&id=7c4715bf&scoped=true"
import script from "./account-drawer.vue?vue&type=script&lang=js"
export * from "./account-drawer.vue?vue&type=script&lang=js"
import style0 from "./account-drawer.vue?vue&type=style&index=0&id=7c4715bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4715bf",
  null
  
)

export default component.exports